import React, { useRef } from 'react';
import { Box, Grid, TextField } from '@material-ui/core';
import useResolution from 'src/hooks/useResolution';
import moment from 'moment';

interface Props {
  fromDateValue?: string | null;
  toDateValue?: string | null;
  size?: 'small' | 'medium';
  onChangeFromDate: (date: string) => void;
  onChangeToDate: (date: string) => void;
}

const normalizeDateFormat = (dateStr: string | null) => {
  if (!dateStr) return null;

  const formattedDate = moment(dateStr, [
    'YYYY-MM-DD HH:mm:ss',
    'MMMM D, YYYY hh:mm:ss A'
  ]).format('YYYY-MM-DDTHH:mm'); // corrected to fit datetime-local input format

  return formattedDate === 'Invalid date' ? null : formattedDate;
};

export const DatePickerRangeComponentV3 = ({
  fromDateValue,
  toDateValue,
  size = 'small',
  onChangeFromDate,
  onChangeToDate
}: Props) => {
  const { xs, md } = useResolution();

  const fromDateRef = useRef<HTMLInputElement | null>(null);
  const toDateRef = useRef<HTMLInputElement | null>(null);

  return (
    <Grid container spacing={2}>
      {/* Start Date */}
      <Grid item xs={12} sm={6}>
        <Box display="flex" flexDirection="column">
          <TextField
            label="Start Date"
            type="datetime-local"
            variant="outlined"
            size={size}
            fullWidth
            value={normalizeDateFormat(fromDateValue ?? null) || ''}
            inputRef={fromDateRef}
            InputLabelProps={{
              shrink: true // ensures label floats properly with datetime-local
            }}
            inputProps={{
              style: {
                ...(xs && { fontSize: '.8em' }),
                ...(md && { fontSize: '1em' })
              }
            }}
            onChange={(e) => onChangeFromDate(e.target.value)}
          />
        </Box>
      </Grid>

      {/* End Date */}
      <Grid item xs={12} sm={6}>
        <Box display="flex" flexDirection="column">
          <TextField
            label="End Date"
            type="datetime-local"
            variant="outlined"
            size={size}
            fullWidth
            value={normalizeDateFormat(toDateValue ?? null) || ''}
            inputRef={toDateRef}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              min: fromDateValue || undefined,
              style: {
                ...(xs && { fontSize: '.8em' }),
                ...(md && { fontSize: '1em' })
              }
            }}
            onChange={(e) => onChangeToDate(e.target.value)}
            disabled={!fromDateValue}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
